import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBwCC2YubRbJ9U5REX2LuNz5ntxmrl4PM8",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "metal-density-504117-k9.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "metal-density-504117-k9",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "metal-density-504117-k9.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "826716276634",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:826716276634:web:e39fb68393526189",
};

// Initialize Firebase once
export const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
export const auth = getAuth(app);

/**
 * Initializes an invisible reCAPTCHA verifier for phone auth.
 */
export function initRecaptchaVerifier(containerId = "firebase-recaptcha-container") {
  if (typeof window === "undefined") return null;

  if (window.firebaseRecaptchaVerifier) {
    try {
      window.firebaseRecaptchaVerifier.clear();
    } catch (e) {
      // ignore clear error
    }
    window.firebaseRecaptchaVerifier = null;
  }

  const container = document.getElementById(containerId);
  if (!container) {
    console.warn(`[Firebase] reCAPTCHA container #${containerId} not found in DOM`);
  }

  window.firebaseRecaptchaVerifier = new RecaptchaVerifier(auth, containerId, {
    size: "invisible",
    callback: () => {
      // reCAPTCHA solved - will proceed with phone auth
    },
    "expired-callback": () => {
      console.warn("[Firebase] reCAPTCHA expired, user may need to re-verify");
    },
  });

  return window.firebaseRecaptchaVerifier;
}

/**
 * Sends OTP SMS to the phone number using Firebase Phone Authentication.
 * @param {string} rawPhone - 10-digit Indian phone number or formatted phone number
 * @param {string} containerId - DOM ID of the container element for reCAPTCHA
 * @returns {Promise<ConfirmationResult>}
 */
export async function sendFirebaseOtp(rawPhone, containerId = "firebase-recaptcha-container") {
  const digits = (rawPhone || "").replace(/\D/g, "").slice(-10);
  if (digits.length !== 10) {
    throw new Error("Please enter a valid 10-digit mobile number");
  }

  const formattedPhone = `+91${digits}`;
  const appVerifier = initRecaptchaVerifier(containerId);
  const confirmationResult = await signInWithPhoneNumber(auth, formattedPhone, appVerifier);
  return confirmationResult;
}

/**
 * Confirms OTP entered by the user and returns the user credentials + ID token.
 * @param {ConfirmationResult} confirmationResult
 * @param {string} otpCode
 * @returns {Promise<{ user: any, idToken: string }>}
 */
export async function verifyFirebaseOtp(confirmationResult, otpCode) {
  if (!confirmationResult || typeof confirmationResult.confirm !== "function") {
    throw new Error("No active OTP session found. Please tap 'Send code'.");
  }
  const code = (otpCode || "").replace(/\D/g, "").slice(0, 6);
  if (code.length !== 6) {
    throw new Error("Please enter the complete 6-digit OTP code");
  }

  const userCredential = await confirmationResult.confirm(code);
  const user = userCredential.user;
  const idToken = await user.getIdToken();
  return { user, idToken };
}

export default app;
